import { useEffect, useState } from 'react';
import axios from 'axios';

export interface Employee {
  ['@odata.etag']: string;
  new_name: string;
  new_employeeid: string;
  cra0e_email: string;
}

export const useGetUser = (userEmail: string) => {
  const [user, setUser] = useState<Employee>();

  const getUser = async () => {
    try {
      const response = await axios.get(
        `api/employees/employee?filter=${userEmail}`
      );
      const employee = response.data;
      setUser(employee);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getUser();
  }, []);

  return { user };
};
